import PDFUpload from "~/components/Input/PDFUpload";
export default function Section4() {
    return (
        <div id="section-4">
            <div className="i-content"></div>
            <PDFUpload></PDFUpload>
        </div>
    )
}